import styles from "./Board.module.css";
import { Tooltip } from "../../components/Tooltip";
import type { ChecksSummaryDetail } from "../../data/api/buildStatuses";
import { checksColorVar, checksTooltip } from "../../lib/checks";

/**
 * A task's CI rollup as one coloured dot, with the state and its counts on
 * hover (`build-status.md` §Repo view).
 *
 * The summary is the server's, computed for the whole page beside the task row
 * — the dot and the task page's pill are the same number, not two clients
 * counting checks for themselves.
 */
export const ChecksDot = ({
  summary,
}: {
  readonly summary: ChecksSummaryDetail;
}) => {
  // Nothing has reported for this commit, which is most of a board most of the
  // time. The empty cell keeps the row's columns lined up with its neighbours'.
  if (summary.state === "none") {
    return <span />;
  }
  const label = checksTooltip(summary.state, summary);
  return (
    <Tooltip content={label}>
      <span
        aria-label={label}
        className={styles.ciDot}
        role="img"
        style={{ background: checksColorVar(summary.state) }}
      />
    </Tooltip>
  );
};
